import { useCallback } from "react"
import { PropTypes } from "prop-types"

import useFastField from "../useFastField"
import TelephoneField from "."

export default function TelephoneFieldWrapper({ name, ...rest }) {
  const { field, error, helpers, touched } = useFastField(name)
  const { setValue } = helpers
  const onChange = useCallback((key, value) => setValue(value), [setValue])

  return (
    <TelephoneField
      {...field}
      error={error}
      onChange={onChange}
      touched={field.value ? touched : false}
      {...rest}
    />
  )
}

TelephoneFieldWrapper.propTypes = {
  name: PropTypes.string.isRequired
}
